import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class OperatingSystemGuard implements CanActivate {
    private readonly router = inject(Router);


    canActivate(): boolean {
        const userAgent = navigator.userAgent;
        const ieBrowser = userAgent.match(/MSIE|Trident/);
        if (ieBrowser && this.windowsVersionNotSupported(userAgent)) {
            this.router.navigateByUrl('/windows-not-supported');
            return false;
        }
        return true;
    }

    private windowsVersionNotSupported(userAgent: string): boolean {
        if (
            userAgent.includes('Windows NT 6.1') ||
            userAgent.includes('Windows NT 6.0') ||
            userAgent.includes('Windows NT 5.2') ||
            userAgent.includes('Windows NT 5.1') ||
            userAgent.includes('Windows NT 5.0')
        ) {
            return true;
        }
        return false;
    }
}
